import { render, staticRenderFns } from "./CoursesEdit.vue?vue&type=template&id=febf2cba&scoped=true&"
import script from "./CoursesEdit.vue?vue&type=script&lang=js&"
export * from "./CoursesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf2cba",
  null
  
)

export default component.exports